import { useEffect, useState } from 'react';
import { getCachedEnvConfig, loadEnvConfig } from '../services/envConfig';
/**
 * The runtime `env.json`: `undefined` while it loads, `null` when it could not be loaded.
 * Callers that must decide from it (the iframe allow-list) wait until it is no longer `undefined`.
 */
export function useEnvConfig() {
    const [env, setEnv] = useState(() => getCachedEnvConfig() ?? undefined);
    useEffect(() => {
        if (env !== undefined)
            return;
        let active = true;
        void loadEnvConfig().then((loaded) => {
            if (active)
                setEnv(loaded);
        });
        return () => {
            active = false;
        };
    }, [env]);
    return env;
}
